import { render, staticRenderFns } from "./formLayout.vue?vue&type=template&id=670b7150&"
import script from "./formLayout.vue?vue&type=script&lang=js&"
export * from "./formLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports